import { fetchWithHandling, fetchWithHandlingNoParse } from "../ApiUtils";
import { login } from "../login/UserLogin";

const EVENTS_URL = `${process.env.REACT_APP_API_URL}/api/admin/events`
const COMMITTEE_URL = `${process.env.REACT_APP_API_URL}/api/admin/committees`
const URL = `${process.env.REACT_APP_API_URL}/api/admin/members`;
const REPORT_URL = `${process.env.REACT_APP_API_URL}/api/report`;
const target = "/admin"

/**
 * GET request to fetch data for the member data.
 */
export const getMemberSearchData = async () => {
    return fetchWithHandling(URL, target, { method: "GET" });
}

// should return ALL events
export const getAllEvents = async () => {
    return fetchWithHandling(`${EVENTS_URL}/all/nonArchive`, target, { method: "GET" });
}

// should return ALL events including archived with filters
export const getAllEventsIncludingArchived = async (data) => {
    return fetchWithHandling(`${EVENTS_URL}/all/filter`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

// should return ALL members including archived with filters
export const getAllMembersIncludingArchived = async (data) => {
    return fetchWithHandling(`${URL}/all/filter`, target, {
        method: "POST",
        body: JSON.stringify(data)
    });
}

// should return ALL committees including archived with filters
export const getAllCommitteesIncludingArchived = async () => {
    return fetchWithHandling(`${COMMITTEE_URL}/all`, target, { method: "GET" });
}

// should return ALL events
export const getAllCommittees = async () => {
    return fetchWithHandling(`${COMMITTEE_URL}/all/nonArchive`, target, { method: "GET" });
}

// should return ALL events
export const getEventTypes = async () => {
    return fetchWithHandling(`${EVENTS_URL}/types`, target, { method: "GET" });
}


export const getAttendanceLink = async (eventId) => {
    return fetchWithHandling(`${EVENTS_URL}/attendanceLink?eventId=${eventId}`, target, { method: "GET" });
}

export const setAttendance = async (eventHash) => {
    console.log(eventHash);
    return fetchWithHandlingNoParse(`${EVENTS_URL}/record`, target, {
        method: "PUT",
        headers: {
            'Content-Type': 'text/plain'
        },
        body: eventHash
    })

}

export const postNewEvent = async (jsonBody) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/new`, target, {
        method: "POST",
        body: JSON.stringify(jsonBody)
    })
}

export const postNewCommittee = async (jsonBody) => {
    return fetchWithHandlingNoParse(`${COMMITTEE_URL}/new`, target, {
        method: "POST",
        body: JSON.stringify(jsonBody)
    })
}

export const postNewEventWithRecurrence = async (jsonBody) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/new/recurrence`, target, {
        method: "POST",
        body: JSON.stringify(jsonBody)
    });
}

export const modifyEventUpdatedRecurrence = async (jsonBody) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/modify/recurrence`, target, {
        method: "PUT",
        body: JSON.stringify(jsonBody)
    });
}

export const modifyEventAndFollowing = async (event) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/modify/future`, target, {
        method: "PUT",
        body: JSON.stringify(event)
    });
}

export const modifyEvent = async (event) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/modify`, target, {
        method: "PUT",
        body: JSON.stringify(event)
    })
}

export const modifyCommittee = async (committee) => {
    return fetchWithHandlingNoParse(`${COMMITTEE_URL}/modify`, target, {
        method: "PUT",
        body: JSON.stringify(committee)
    })
}

export const modifyMember = async (member) => {
    return fetchWithHandlingNoParse(`${URL}/modify`, target, {
        method: "PUT",
        body: JSON.stringify(member)
    })
}

export const duplicateEvent = async (event) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/duplicate`, target, {
        method: "POST",
        body: JSON.stringify(event)
    })
}

export const archiveEvent = async (event, deleteFollowing) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/archive/${deleteFollowing}`, target, {
        method: "DELETE",
        body: JSON.stringify(event)
    })
}

export const archiveCommittee = async (committee) => {
    return fetchWithHandlingNoParse(`${COMMITTEE_URL}/archive`, target, {
        method: "DELETE",
        body: JSON.stringify(committee)
    })
}

export const restoreCommittee = async (committee) => {
    return fetchWithHandlingNoParse(`${COMMITTEE_URL}/restore`, target, {
        method: "PUT",
        body: JSON.stringify(committee)
    })
}

export const restoreEvent = async (event) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/restore`, target, {
        method: "PUT",
        body: JSON.stringify(event)
    })
}

export const deleteEventRecurrence = async (event, deleteFollowing) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/delete/recurrence/${deleteFollowing}`, target, {
        method: "DELETE",
        body: JSON.stringify(event)
    });
}

export const deleteEvent = async (event, deleteFollowing) => {
    return fetchWithHandlingNoParse(`${EVENTS_URL}/delete/${deleteFollowing}`, target, {
        method: "DELETE",
        body: JSON.stringify(event)
    })
}

export const fetchGenerateReport = async (report, format) => {
    return fetchWithHandlingNoParse(`${REPORT_URL}/${report}/${format}`, target, {
        method: "GET"
    })
}
